import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="report-link"
export default class extends Controller {
  static targets = ["button"]
  declare readonly buttonTarget: HTMLElement

  connect() {
    document.addEventListener("click", this.handleOutsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick)
  }

  toggle(event: Event) {
    event.stopPropagation()
    this.buttonTarget.classList.toggle("is_active")
  }

  handleOutsideClick = () => {
    this.buttonTarget.classList.remove("is_active")
  }
}
